import React from "react";
import theme from "../../../styles/theme";



const Page54 = () => {
  return (
    <div>
    <h2>"Page 54" </h2>
    </div>

  );
};

export default Page54;
